import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';
import { AppConstants } from 'src/app/config.service';

@Component({
  templateUrl: './unauthorised-page.component.html',
  styleUrls: ['./unauthorised-page.component.scss']
})

export class UnauthorizedComponent {

  constructor(
    private appConstants: AppConstants,
    private authService: AuthService,
    private router: Router
  ) { }

  isTenantUserIdAvailable: boolean = false;
  isRoleAvailable: boolean = false;
  isLoader: boolean = true;
  ngOnInit() {
    this.appConstants.setupLoader.subscribe((res) => {
      this.isLoader = res;
    });
  }

  async checkUserAccess() {
    await this.appConstants.checkTenantUserId();
    this.isTenantUserIdAvailable = this.appConstants.tenantUserId && this.appConstants.tenantUserId.length ? true : false;
    this.isRoleAvailable = await this.authService.checkRoleExist('trutesta-ulc');
    if (this.isTenantUserIdAvailable && this.isRoleAvailable)
      this.router.navigate(['/customers'])
  }

}

